import { fg } from '@atlassian/jira-feature-gating';

export const getWillShowNav4UserOptOutForVisualRefresh = () =>
	fg('visual-refresh') &&
	(fg('visual-refresh-dogfood') ||
		fg('visual-refresh-eap') ||
		fg('visual-refresh-beta-existing-customers'));
